<div class="modal-header">
    <h5 class="modal-title">{{ notice.id ? 'Chỉnh sửa' : 'Thêm' }} Thông Báo</h5>
    <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="notificationMethod">Phương Thức Thông Báo</label>
        <select class="form-control" id="notificationMethod"  [(ngModel)]="notice.notificationMethod" name="notificationMethod">
          <option value="sms">SMS</option>
          <option value="email">Email</option>
        </select>
      </div>
    
      <div class="form-group">
        <label for="receiver">Người Nhận</label>
        <select class="form-control" id="receiver"  [(ngModel)]="notice.receiver" name="receiver">
          <option *ngFor="let receiver of members" [value]="receiver.primary_email">{{ receiver.firstname+' '+receiver.surname }}</option>
        </select>
      </div>
    
      <div class="form-group">
        <label for="subject">Chủ Đề</label>
        <select class="form-control" id="subject"  [(ngModel)]="notice.subject" name="subject">
          <option *ngFor="let n of noticeTemplates" [value]="n.contentTemplate">{{ n.title }}</option>
        </select>     
      </div>
    
      <div class="form-group">
        <label for="type">Loại</label>
        <select class="form-control" id="type"  [(ngModel)]="notice.type" name="type">
          <option value="notification">Thông Báo</option>
          <option value="alert">Cảnh Báo</option>
          <option value="reminder">Nhắc Nhở</option>
        </select>
      </div>
    
      <div class="form-group">
        <label for="importance">Mức Độ Quan Trọng</label>
        <select class="form-control" id="importance"  [(ngModel)]="notice.importance" name="importance">
          <option value="high">Cao</option>
          <option value="medium">Trung Bình</option>
          <option value="low">Thấp</option>
        </select>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Cancel</button>
    <button type="button" class="btn btn-outline-primary" (click)="saveNotice()">Save</button>
  </div>

